/* Sable-UnderG theme JS — menu, AJAX cart drawer, variants, gallery, accordions, filters, reveal.
 * Vanilla JS, no build step. Ported from the static Sable storefront; cart is Shopify AJAX. */
(function () {
  "use strict";
  var CFG = window.SableTheme || {};
  var S = CFG.strings || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function fmtNum(cents, precision, thousands, decimal) {
    var value = (Math.abs(cents) / 100).toFixed(precision);
    var parts = value.split(".");
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands || ",");
    return (cents < 0 ? "-" : "") + (parts[1] ? whole + (decimal || ".") + parts[1] : whole);
  }
  function money(cents) {
    var fmt = CFG.moneyFormat || "£{{amount}}";
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case "amount": return fmtNum(cents, 2, ",", ".");
        case "amount_no_decimals": return fmtNum(cents, 0, ",", ".");
        case "amount_with_comma_separator": return fmtNum(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return fmtNum(cents, 0, ".", ",");
        case "amount_with_space_separator": return fmtNum(cents, 2, " ", ",");
        case "amount_no_decimals_with_space_separator": return fmtNum(cents, 0, " ", ",");
        case "amount_with_apostrophe_separator": return fmtNum(cents, 2, "'", ".");
        default: return fmtNum(cents, 2, ",", ".");
      }
    });
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l4 4L19 6"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  /* ---------- toasts ---------- */
  function toast(msg) {
    var box = $("[data-toasts]"); if (!box) return;
    var t = document.createElement("div");
    t.className = "toast"; t.innerHTML = CHECK + "<span>" + esc(msg) + "</span>";
    box.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("show"); });
    setTimeout(function () { t.classList.remove("show"); setTimeout(function () { t.remove(); }, 320); }, 2600);
  }

  /* ---------- count ---------- */
  function setCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      var prev = parseInt(el.textContent, 10) || 0;
      el.textContent = n;
      if (n !== prev) {
        var link = el.closest(".cart-link");
        if (link) { link.classList.remove("bump"); void link.offsetWidth; link.classList.add("bump"); setTimeout(function () { link.classList.remove("bump"); }, 550); }
      }
    });
  }

  /* ---------- mobile menu ---------- */
  function initMenu() {
    var menu = $("[data-mmenu]"); if (!menu) return;
    var open = $("[data-menu]"), close = $("[data-mclose]", menu);
    if (open) open.addEventListener("click", function () { menu.classList.add("open"); document.body.classList.add("lock"); open.setAttribute("aria-expanded", "true"); });
    if (close) close.addEventListener("click", function () { menu.classList.remove("open"); document.body.classList.remove("lock"); if (open) open.setAttribute("aria-expanded", "false"); });
    $$(".mmenu__links a", menu).forEach(function (a) { a.addEventListener("click", function () { menu.classList.remove("open"); document.body.classList.remove("lock"); }); });
  }

  /* ---------- cart drawer ---------- */
  var drawer, scrim;
  function getCart() { return fetch(CFG.cartUrl ? CFG.cartUrl + ".js" : "/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }); }
  function openDrawer() {
    drawer = drawer || $("[data-cart-drawer]"); scrim = scrim || $("[data-scrim]");
    if (!drawer) return;
    getCart().then(function (cart) {
      renderDrawer(cart);
      drawer.classList.add("open"); scrim.classList.add("open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("lock");
    });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("open"); if (scrim) scrim.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("lock");
  }
  function lineHTML(it) {
    var img = it.image ? '<img src="' + it.image + '" alt="" width="70" height="88">' : "";
    return '<div class="line" data-key="' + esc(it.key) + '">' +
      '<div class="line__img">' + img + '</div>' +
      '<div><div class="line__name">' + esc(it.product_title) + '</div>' +
      (it.variant_title && it.variant_title.indexOf("Default") < 0 ? '<div class="line__var">' + esc(it.variant_title) + '</div>' : '') +
      '<div class="qtm"><button type="button" data-dec aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-inc aria-label="Increase">+</button></div>' +
      '<a class="line__rm" data-rm role="button" tabindex="0">' + (S.remove || "Remove") + '</a></div>' +
      '<div class="line__price">' + money(it.final_line_price) + '</div></div>';
  }
  function renderDrawer(cart) {
    setCount(cart.item_count);
    var head = '<div class="drawer__head"><h2>Your bag</h2><button class="icon" data-dclose aria-label="Close">' + CLOSE + '</button></div>';
    if (!cart.item_count) {
      drawer.innerHTML = head + '<div class="drawer__empty"><p>' + (S.emptyCart || "Your bag's empty.") + '</p><p style="margin-top:18px"><a class="tlink" href="' + (CFG.allUrl || "/collections/all") + '">' + (S.startShopping || "Start shopping") + ' ' + ARROW + '</a></p></div>';
      wireDrawer(); return;
    }
    var ship = "";
    var t = CFG.freeShipThreshold || 0;
    if (t > 0) {
      var left = t - cart.total_price;
      var pct = Math.min(100, 100 * cart.total_price / t);
      ship = '<div class="shipbar">' + (left > 0 ? (S.freeShipProgress || "Spend {x} more for free delivery").replace("{x}", money(left)) : '<span style="color:var(--color-success)">' + (S.freeShipUnlocked || "Free delivery unlocked.") + '</span>') +
        '<div class="shipbar__t"><div class="shipbar__f" style="width:' + pct + '%"></div></div></div>';
    }
    var lines = cart.items.map(lineHTML).join("");
    drawer.innerHTML = head + ship + '<div class="drawer__body">' + lines + '</div>' +
      '<div class="drawer__foot"><div class="subtotal"><span class="muted">' + (S.subtotal || "Subtotal") + '</span><span class="a">' + money(cart.total_price) + '</span></div>' +
      '<div class="foot-note">' + (S.shippingNote || "Shipping and tax at checkout.") + '</div>' +
      '<a class="btn btn--block" href="/checkout">' + (S.checkout || "Checkout") + '</a>' +
      '<a class="tlink" style="align-self:center" href="' + (CFG.cartUrl || "/cart") + '">' + (S.viewBag || "View bag") + '</a></div>';
    wireDrawer();
  }
  function changeLine(key, qty) {
    return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); return cart; });
  }
  function wireDrawer() {
    var c = $("[data-dclose]", drawer); if (c) c.addEventListener("click", closeDrawer);
    $$(".line", drawer).forEach(function (row) {
      var key = row.getAttribute("data-key");
      var qtyEl = $(".qtm span", row), qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var inc = $("[data-inc]", row), dec = $("[data-dec]", row), rm = $("[data-rm]", row);
      if (inc) inc.addEventListener("click", function () { changeLine(key, qty + 1); });
      if (dec) dec.addEventListener("click", function () { changeLine(key, qty - 1); });
      if (rm) {
        rm.addEventListener("click", function () { changeLine(key, 0); });
        rm.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); changeLine(key, 0); } });
      }
    });
  }
  function initDrawer() {
    drawer = $("[data-cart-drawer]"); scrim = $("[data-scrim]");
    if (scrim) scrim.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });
    document.addEventListener("click", function (e) {
      var open = e.target.closest("[data-cart-open]");
      if (open) { e.preventDefault(); openDrawer(); }
    });
  }

  /* ---------- add to cart (PDP) ---------- */
  function bundleVariants() {
    var el = $("[data-variants]"); if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function buildBundleItems(pick, form) {
    var variants = bundleVariants(); if (!variants) return null;
    var colorPos = parseInt(pick.getAttribute("data-color-pos"), 10) || 0;
    var sizePos = parseInt(pick.getAttribute("data-size-pos"), 10) || 0;
    var size = null;
    if (sizePos) {
      var sInp = $$("[data-option-input]:checked", form).filter(function (i) { return (+i.getAttribute("data-position")) === sizePos; })[0];
      size = sInp ? sInp.value : null;
      if (!size) return null;
    }
    var counts = {};
    $$("[data-pick-row]", pick).filter(function (r) { return !r.hidden; }).forEach(function (r) {
      var sel = $("[data-pick-color]", r); if (!sel) return;
      var color = sel.value, v = null;
      for (var i = 0; i < variants.length; i++) {
        var ok = variants[i].options[colorPos - 1] === color;
        if (ok && sizePos) ok = variants[i].options[sizePos - 1] === size;
        if (ok) { v = variants[i]; break; }
      }
      if (v) counts[v.id] = (counts[v.id] || 0) + 1;
    });
    var items = Object.keys(counts).map(function (k) { return { id: parseInt(k, 10), quantity: counts[k] }; });
    return items.length ? items : null;
  }
  function initProductForm() {
    var form = $("[data-product-form]") || $("[data-product] form"); if (!form) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var idEl = $("[data-variant-id]", form), qtyEl = $("[data-qty]", form);
      var id = idEl ? idEl.value : null;
      var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
      var bundles = $("[data-bundles]"), bundleCode = "", pick = $("[data-bundle-pick]"), items = null, isSet = false;
      if (bundles && bundles._tier) {
        var t = bundles._tier;
        bundleCode = t.getAttribute("data-code") || "";
        if (t.getAttribute("data-set")) {
          isSet = true;
          var setEl = $("[data-set-addon]");
          var pv = setEl && setEl._resolve ? setEl._resolve() : null;
          if (id && pv) { items = [{ id: parseInt(id, 10), quantity: 1 }, { id: pv.id, quantity: 1 }]; }
        } else {
          qty = parseInt(t.getAttribute("data-qty"), 10) || 1;
          if (qty > 1 && pick && !pick.hidden) { items = buildBundleItems(pick, form); }
        }
      }
      var hint = $("[data-form-hint]");
      var btn = $("[data-add]", form);
      if (isSet && !items) { if (hint) hint.textContent = "Please choose your set options."; return; }
      if (!items && !id) { if (hint) hint.textContent = "Please choose your options."; return; }
      if (!isSet && qty > 1 && pick && !pick.hidden && !items) { if (hint) hint.textContent = "Please choose your size first."; return; }
      if (btn) btn.disabled = true;
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(items ? { items: items } : { id: id, quantity: qty }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (btn) btn.disabled = false;
          if (!res.ok) { if (hint) hint.textContent = (res.d && res.d.description) || "Sorry, that's not available."; return; }
          if (hint) hint.textContent = "";
          if (bundleCode) { window.location.href = "/discount/" + encodeURIComponent(bundleCode) + "?redirect=" + encodeURIComponent(CFG.cartUrl || "/cart"); return; }
          toast(S.added || "Added to your bag");
          openDrawer();
        })
        .catch(function () { if (btn) btn.disabled = false; if (hint) hint.textContent = "Something went wrong. Try again."; });
    });
  }

  /* ---------- variant selection (PDP) ---------- */
  function initVariants() {
    var wrap = $("[data-product]"); if (!wrap) return;
    var dataEl = $("[data-variants]"); if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = $("[data-product-form]") || $("[data-product] form");
    var idEl = $("[data-variant-id]", form);
    var priceEl = $("[data-price]"), compareEl = $("[data-compare]");
    var addBtn = $("[data-add]", form), addText = $("[data-add-text]", form);
    var gal = $("[data-gallery]");
    var hasBundles = !!$("[data-bundles]");

    function selected() {
      var inputs = $$("[data-option-input]:checked", form);
      // order by position
      inputs.sort(function (a, b) { return (+a.getAttribute("data-position")) - (+b.getAttribute("data-position")); });
      return inputs.map(function (i) { return i.value; });
    }
    function match() {
      var sel = selected();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) { if (v.options[j] !== sel[j]) { ok = false; break; } }
        if (ok && v.options.length === sel.length) return v;
      }
      return null;
    }
    function update(skipGallery) {
      var v = match();
      // active states
      $$("[data-option-input]", form).forEach(function (inp) {
        var label = inp.closest("label");
        if (label) label.classList.toggle("active", inp.checked);
      });
      var colorLabel = $("[data-option-selected]");
      if (colorLabel) {
        var colorInput = $$("[data-option-input]:checked", form).filter(function (i) {
          var grp = i.closest("[data-option-group]");
          return grp && /colou?r/i.test($(".opt__lab", grp).textContent);
        })[0];
        if (colorInput) colorLabel.textContent = colorInput.value;
      }
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addText) addText.textContent = "Unavailable";
        return;
      }
      if (idEl) idEl.value = v.id;
      if (!hasBundles) {
        if (priceEl) { priceEl.textContent = v.price; priceEl.classList.toggle("price-sale", !!v.compare); }
        if (compareEl) { if (v.compare) { compareEl.textContent = v.compare; compareEl.hidden = false; } else { compareEl.textContent = ""; compareEl.hidden = true; } }
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? "Add to bag" : "Sold out";
      if (!skipGallery && v.mid && gal && gal._goToMedia) gal._goToMedia(v.mid);
    }
    $$("[data-option-input]", form).forEach(function (inp) { inp.addEventListener("change", function () { update(false); }); });
    update(true);
  }

  /* ---------- gallery carousel (swipeable track + thumbs + arrows) ---------- */
  function initGallery() {
    var gal = $("[data-gallery]"); if (!gal) return;
    var track = $("[data-gallery-track]", gal); if (!track) return;
    var slides = $$(".gallery__slide", track);
    var thumbs = $$("[data-thumb]", gal);
    var prev = $("[data-gallery-prev]", gal), next = $("[data-gallery-next]", gal);
    function index() { var w = track.clientWidth; return w ? Math.round(track.scrollLeft / w) : 0; }
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle("active", k === i); });
      // Keep the active thumb visible by scrolling ONLY the horizontal thumb strip.
      // (scrollIntoView with block:"nearest" was scrolling the whole PAGE vertically —
      // on mobile, the address-bar resize fired setActive and yanked the viewport to the top.)
      var at = thumbs[i];
      if (at) {
        var wrap = at.closest("[data-gallery-thumbs]") || at.parentNode;
        if (wrap && wrap.scrollWidth > wrap.clientWidth + 1) {
          var wr = wrap.getBoundingClientRect(), tr = at.getBoundingClientRect();
          if (tr.left < wr.left || tr.right > wr.right) {
            wrap.scrollBy({ left: (tr.left - wr.left) - (wrap.clientWidth - at.offsetWidth) / 2, behavior: "smooth" });
          }
        }
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" });
    }
    thumbs.forEach(function (t) { t.addEventListener("click", function () { goTo(+t.getAttribute("data-index")); }); });
    if (next) next.addEventListener("click", function () { goTo(index() + 1); });
    if (prev) prev.addEventListener("click", function () { goTo(index() - 1); });
    var raf;
    track.addEventListener("scroll", function () { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { setActive(index()); }); }, { passive: true });
    window.addEventListener("resize", function () { setActive(index()); });
    setActive(0);
    // let the variant picker jump the gallery to a colour's image
    gal._goToMedia = function (mid) {
      for (var k = 0; k < slides.length; k++) {
        if (slides[k].getAttribute("data-media-id") === String(mid)) { goTo(k); return; }
      }
    };
  }

  /* ---------- accordions ---------- */
  function initAccordions() {
    $$("[data-acc]").forEach(function (b) {
      b.addEventListener("click", function () {
        var item = b.parentElement, panel = $(".acc__p", item), open = item.classList.contains("open");
        item.classList.toggle("open");
        panel.style.maxHeight = open ? "0" : (panel.firstElementChild.scrollHeight + 24) + "px";
      });
    });
  }

  /* ---------- qty steppers (PDP) ---------- */
  function initQty() {
    var up = $("[data-qty-up]"), down = $("[data-qty-down]"), input = $("[data-qty]");
    if (!input) return;
    function clamp() { input.value = Math.max(1, Math.min(99, parseInt(input.value, 10) || 1)); }
    if (up) up.addEventListener("click", function () { input.value = (parseInt(input.value, 10) || 1) + 1; clamp(); });
    if (down) down.addEventListener("click", function () { input.value = (parseInt(input.value, 10) || 1) - 1; clamp(); });
    input.addEventListener("change", clamp);
  }

  /* ---------- bundle & save tiers (PDP) ---------- */
  function initBundles() {
    var box = $("[data-bundles]"); if (!box) return;
    var tiers = $$("[data-btier]", box);
    var priceEl = $("[data-price]"), compareEl = $("[data-compare]");
    var pick = $("[data-bundle-pick]");
    var setpick = $("[data-set-addon]");
    var rows = pick ? $$("[data-pick-row]", pick) : [];
    function topColor() {
      if (!pick) return null;
      var cp = pick.getAttribute("data-color-pos");
      var inp = $$("[data-option-input]:checked").filter(function (i) { return i.getAttribute("data-position") === cp; })[0];
      return inp ? inp.value : null;
    }
    function updatePicker(qty) {
      if (!pick) return;
      if (qty > 1) {
        pick.hidden = false;
        var tc = topColor();
        rows.forEach(function (r, i) {
          r.hidden = i >= qty;
          if (i < qty) { var sel = $("[data-pick-color]", r); if (sel && !sel._touched && tc) sel.value = tc; }
        });
      } else { pick.hidden = true; }
    }
    function apply(tier) {
      if (!tier) return;
      box._tier = tier;
      tiers.forEach(function (t) { t.classList.toggle("btier--active", t === tier); });
      var input = $("[data-btier-input]", tier); if (input) input.checked = true;
      var p = tier.getAttribute("data-price"), c = tier.getAttribute("data-compare");
      if (priceEl && p) { priceEl.textContent = p; priceEl.classList.toggle("price-sale", !!c); }
      if (compareEl) {
        if (c) { compareEl.textContent = c; compareEl.hidden = false; }
        else { compareEl.textContent = ""; compareEl.hidden = true; }
      }
      updatePicker(parseInt(tier.getAttribute("data-qty"), 10) || 1);
      if (setpick) setpick.hidden = !tier.getAttribute("data-set");
    }
    tiers.forEach(function (tier) {
      tier.addEventListener("change", function () { apply(tier); });
      tier.addEventListener("click", function () { apply(tier); });
    });
    rows.forEach(function (r) { var sel = $("[data-pick-color]", r); if (sel) sel.addEventListener("change", function () { sel._touched = true; }); });
    if (pick) {
      $$("[data-option-input]").forEach(function (inp) {
        if (inp.getAttribute("data-position") === pick.getAttribute("data-color-pos")) {
          inp.addEventListener("change", function () { var t = box._tier; if (t) updatePicker(parseInt(t.getAttribute("data-qty"), 10) || 1); });
        }
      });
    }
    var checked = tiers.filter(function (t) { var i = $("[data-btier-input]", t); return i && i.checked; })[0];
    apply(checked || tiers[0]);
  }

  /* ---------- collection sort + filters ---------- */
  function initCollection() {
    var sort = $("[data-sort]");
    if (sort) sort.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sort.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
    var form = $("[data-filter-form]");
    if (form) {
      form.addEventListener("change", function (e) {
        if (e.target && e.target.matches("input")) form.submit();
      });
    }
    var toggle = $("[data-filter-toggle]"), filters = $("[data-filters]"), close = $("[data-filter-close]");
    if (toggle && filters) toggle.addEventListener("click", function () { filters.classList.add("open"); document.body.classList.add("lock"); });
    if (close && filters) close.addEventListener("click", function () { filters.classList.remove("open"); document.body.classList.remove("lock"); });
  }

  /* ---------- cart page qty ---------- */
  function initCartPage() {
    var form = $("[data-cart-form]"); if (!form) return;
    $$("[data-cart-item]", form).forEach(function (row) {
      var key = row.getAttribute("data-key");
      var valEl = $("[data-qm-value]", row), qty = valEl ? parseInt(valEl.textContent, 10) : 1;
      var up = $("[data-qm-up]", row), down = $("[data-qm-down]", row);
      function go(n) {
        if (n < 0) return;
        fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ id: key, quantity: n }) })
          .then(function (r) { return r.json(); }).then(function () { window.location.reload(); });
      }
      if (up) up.addEventListener("click", function () { go(qty + 1); });
      if (down) down.addEventListener("click", function () { go(qty - 1); });
    });
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    var els = $$(".reveal");
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("in"); io.unobserve(x.target); } });
    }, { threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- header scroll ---------- */
  function initHeader() {
    var h = $("[data-header]"); if (!h) return;
    window.addEventListener("scroll", function () { h.classList.toggle("scrolled", window.scrollY > 30); }, { passive: true });
  }

  /* ---------- reviews carousel ---------- */
  function initReviewCarousel() {
    var track = $("[data-rev-track]"); if (!track) return;
    var prev = $("[data-rev-prev]"), next = $("[data-rev-next]");
    function refresh() {
      var max = track.scrollWidth - track.clientWidth - 4;
      var canScroll = track.scrollWidth > track.clientWidth + 8;
      if (prev) prev.disabled = !canScroll || track.scrollLeft <= 4;
      if (next) next.disabled = !canScroll || track.scrollLeft >= max;
    }
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: track.clientWidth, behavior: "smooth" }); });
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -track.clientWidth, behavior: "smooth" }); });
    track.addEventListener("scroll", refresh, { passive: true });
    window.addEventListener("resize", refresh);
    refresh();
  }

  /* ---------- size guide modal ---------- */
  function initSizeGuide() {
    var modal = $("[data-size-modal]"); if (!modal) return;
    var content = $("[data-size-content]", modal), titleEl = $("[data-size-title]", modal);
    function show() { modal.hidden = false; requestAnimationFrame(function () { modal.classList.add("open"); }); document.body.classList.add("lock"); }
    function hide() { modal.classList.remove("open"); document.body.classList.remove("lock"); setTimeout(function () { modal.hidden = true; }, 300); }
    function openWith(handle) {
      var src = handle ? $('[data-chart-src="' + handle + '"]') : null;
      if (src && content) content.innerHTML = src.innerHTML;
      if (src && titleEl) { var t = src.getAttribute("data-chart-title"); if (t) titleEl.textContent = t; }
      show();
    }
    modal._openChart = openWith;
    var opener = $("[data-size-open]");
    if (opener) opener.addEventListener("click", function () { openWith(modal.getAttribute("data-current-handle")); });
    $$("[data-size-close]", modal).forEach(function (el) { el.addEventListener("click", hide); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !modal.hidden) hide(); });
    if (window.location.hash === "#size-guide") setTimeout(function () { openWith(modal.getAttribute("data-current-handle")); }, 250);
  }

  /* ---------- complete the set cross-sell ---------- */
  function initSetAddon() {
    var box = $("[data-set-addon]"); if (!box) return;
    var dataEl = $("[data-set-partners]", box); if (!dataEl) return;
    var partners; try { partners = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!partners.length) return;
    var _pre = {};
    function preloadImg(u) { if (u && !_pre[u]) { _pre[u] = 1; (new Image()).src = u; } }
    partners.forEach(function (pp) { preloadImg(pp.image); pp.variants.forEach(function (v) { preloadImg(v.img); }); });
    var ui = $("[data-set-ui]", box), hint = $("[data-set-hint]", box);
    var code = box.getAttribute("data-set-code") || "";
    var state = { partner: partners[0] };
    function optIndex(p, re) { for (var i = 0; i < p.optnames.length; i++) { if (re.test(p.optnames[i])) return i; } return -1; }
    function key(i) { return i === 0 ? "o1" : (i === 1 ? "o2" : "o3"); }
    function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;"); }
    function render() {
      var p = state.partner;
      var ci = optIndex(p, /colou?r/i), si = optIndex(p, /size/i);
      var ck = key(ci), sk = key(si), colors = [], sizes = [];
      p.variants.forEach(function (v) {
        if (ci > -1 && v[ck] != null && colors.indexOf(v[ck]) < 0) colors.push(v[ck]);
        if (si > -1 && v[sk] != null && sizes.indexOf(v[sk]) < 0) sizes.push(v[sk]);
      });
      var html = '<div class="setbox__item">';
      if (p.image) html += '<img class="setbox__img" src="' + p.image + '" alt="" width="48" height="60" loading="lazy">';
      html += '<span class="setbox__name">' + esc(p.title) + '</span></div>';
      if (partners.length > 1) html += '<label class="setbox__row"><span class="setbox__lab">Item</span><span class="setbox__sel"><select data-set-partner>' + partners.map(function (pp, i) { return '<option value="' + i + '"' + (pp === state.partner ? ' selected' : '') + '>' + esc(pp.title) + '</option>'; }).join("") + '</select></span></label>';
      if (ci > -1) html += '<label class="setbox__row"><span class="setbox__lab">Colour</span><span class="setbox__sel"><select data-set-color>' + colors.map(function (c) { return '<option value="' + esc(c) + '">' + esc(c) + '</option>'; }).join("") + '</select></span></label>';
      if (si > -1) html += '<label class="setbox__row"><span class="setbox__lab">Size</span><span class="setbox__sel"><select data-set-size>' + sizes.map(function (s) { return '<option value="' + esc(s) + '">' + esc(s) + '</option>'; }).join("") + '</select></span></label>';
      ui.innerHTML = html;
    }
    function resolveVariant() {
      var p = state.partner;
      var ci = optIndex(p, /colou?r/i), si = optIndex(p, /size/i), ck = key(ci), sk = key(si);
      var color = (ui.querySelector("[data-set-color]") || {}).value;
      var size = (ui.querySelector("[data-set-size]") || {}).value;
      return p.variants.filter(function (v) {
        var ok = true;
        if (ci > -1) ok = ok && v[ck] === color;
        if (si > -1) ok = ok && v[sk] === size;
        return ok;
      })[0];
    }
    var chartBtn = $("[data-set-chart]", box);
    if (chartBtn) chartBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var modal = $("[data-size-modal]");
      if (modal && modal._openChart) modal._openChart(state.partner.handle);
    });
    function updateImage() {
      var p = state.partner;
      var ci = optIndex(p, /colou?r/i), ck = key(ci);
      var color = (ui.querySelector("[data-set-color]") || {}).value;
      var v = ci > -1 ? p.variants.filter(function (x) { return x[ck] === color; })[0] : null;
      var imgEl = ui.querySelector(".setbox__img");
      var src = (v && v.img) ? v.img : p.image;
      if (imgEl && src) imgEl.setAttribute("src", src);
    }
    function updateProductLink() {
      var link = $("[data-set-product]", box);
      if (link && state.partner) link.setAttribute("href", "/products/" + state.partner.handle);
    }
    ui.addEventListener("change", function (e) {
      var el = e.target; if (!el || !el.getAttribute) return;
      if (el.getAttribute("data-set-partner") !== null) { state.partner = partners[+el.value]; render(); updateImage(); updateProductLink(); }
      else if (el.getAttribute("data-set-color") !== null) { updateImage(); }
    });
    box._resolve = resolveVariant;
    render();
    updateImage();
    updateProductLink();
  }

  function boot() {
    CFG.allUrl = "/collections/all";
    initMenu(); initDrawer(); initProductForm(); initGallery(); initVariants(); initBundles();
    initAccordions(); initQty(); initCollection(); initCartPage(); initReveal(); initHeader();
    initReviewCarousel(); initSizeGuide(); initSetAddon();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
